module.exports = __webpack_public_path__ + "static/media/books.2973a5e7.svg";